import React from 'react';
import {
  ShellyOAuth as OAuth,
  NetatmoOauth,
  DaikinOICD,
  EbecoAuth,
  SensiboAuth,
  GoeAuth
} from './auth';
import { useUser } from './UserContext';
import './settings.css';
import { logger } from './utils/logger';

//import Header from './Header.js'

function Settings() {
  const { userData, jwtToken, viewingAs } = useUser();

  // Use viewingAs account if admin is viewing another user, otherwise use own account
  const effectiveAccountName = viewingAs?.accountName || userData?.accountName;

  const generateSessionToken = () => {
    if (!jwtToken) {
      logger.error('No JWT token available');
      return null;
    }

    //const jwtToken = user.session.tokens.idToken.toString();
    const sessionToken = jwtToken.substring(0, 10);
    logger.log("SESSION TOKEN", sessionToken);
    return sessionToken;
  };

  /**
   * Generic function to save credentials for third-party services
   * @param {string} credentialType - Type of credentials (e.g., 'ebeco_credentials', 'sensibo_credentials', 'goe_credentials')
   * @param {Object} credentials - Dictionary of credential fields (e.g., {username, password}, {api_key}, {device_id, api_key})
   * @returns {Promise<Object>} - Object with {success: boolean, message: string}
   */
  const saveCredentials = async (credentialType, credentials) => {
    logger.log(`Starting to save ${credentialType}`, credentials);

    try {
      const response = await fetch('https://j1jjasmb97.execute-api.eu-north-1.amazonaws.com/SaveConfigs-API', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwtToken}`
        },
        body: JSON.stringify({
          account_name: effectiveAccountName,
          [credentialType]: credentials
        })
      });

      if (!response.ok) {
        throw new Error('Save failed');
      }

      logger.log(`${credentialType} saved successfully`);
      return { success: true, message: 'Saved successfully!' };

    } catch (error) {
      logger.error(`Error saving ${credentialType}:`, error);
      return { success: false, message: 'Error saving credentials' };
    }
  };

  const sessionToken = generateSessionToken();

  return (
    <>
    <div className="settings-container">
      <h1 className="settings-title">Authorizations</h1>
      {/*
      {sessionToken ? (
        <div className="user-session-info">
          Session active: {sessionToken}
        </div>
      ) : (
        <div className="error-message">
          Please login to enable OAuth providers
        </div>
      )} */}
        <OAuth sessionToken={sessionToken}/>
        <NetatmoOauth sessionToken={sessionToken} />
        <DaikinOICD sessionToken={sessionToken} saveCredentials={saveCredentials} />
        <EbecoAuth saveCredentials={saveCredentials} />
        <SensiboAuth saveCredentials={saveCredentials} />
        <GoeAuth saveCredentials={saveCredentials} />
      </div>
    </>
  );
}

export default Settings;